import { isNil, pluck, filter, includes } from 'ramda'
import React from 'react'
import Select from 'react-select'
import CircularProgress from 'components/CircularProgress'
import IntlMessages from 'util/IntlMessages'

export const paymentWidget = (props) => {
  const {canUseStripe} = props.options
  switch (true) {
    case isNil(canUseStripe):
      return <div className="body-text"><em><IntlMessages id={'component.specialistDetails.payment.chooseCountryFirst'} /></em></div>
    case !canUseStripe:
      return <div className="body-text"><IntlMessages id={'component.specialistDetails.payment.externalMethods'} /></div>
    case canUseStripe:
      return <StripeWidget currentAccountId={props.value}/>
  }
}

const StripeWidget = ({currentAccountId}) =>
  isNil(currentAccountId) ? (
      <a href={
        'https://connect.stripe.com/oauth/authorize' +
        '?response_type=code' +
        `&client_id=${process.env.STRIPE_CLIENT_ID}` +
        '&scope=read_write' +
        `&redirect_uri=${process.env.THIS_HOST}/stripe-callback`
      }>
        <img src='/vendors/stripe/PNG button - blue/blue-on-light.png' style={{marginLeft: '2rem'}} onClick={() => true}/>
      </a>
    ) :
    <span className='btn-success btn justify-content-center align-middle' style={{marginLeft: '2rem'}}>Connected <i
      className={'zmdi zmdi-shield-check email-verified'}/></span>


const showErrors = (options, rawErrors) => options && options.hideErrorMessage ? null :
  <span className="field-select-error">{rawErrors && rawErrors.length > 0 ? rawErrors : null}</span>



export const singleSelectWidget = (props) => {
  const {options, rawErrors} = props
  return <div>
    <Select
      options={props.options.enumOptions}
      value={props.options.enumOptions.filter(({value}) => value === props.value)}
      onChange={option => props.onChange(option ? option.value : null)}
      isDisabled={props.options.disabled}
      isClearable={true}
      placeholder={props.placeholder}
      className="no-danger"
      classNamePrefix="react-select"
      maxMenuHeight={600}
    />
    {showErrors(options, rawErrors)}
  </div>
}

export const multiSelectWidget = (props) => {
  const {options, rawErrors} = props
  return <div><Select
    options={props.options.enumOptions}
    isMulti={true}
    value={filter(
      option => includes(option.value, props.value),
      props.options.enumOptions
    )}
    onChange={options => props.onChange(pluck('value', options))}
    placeholder={props.options.placeholder}
    closeMenuOnSelect={false}
    className="no-danger"
    classNamePrefix="react-select"
    maxMenuHeight={600}
    menuPosition={'fixed'}
  />
    {showErrors(options, rawErrors)}
  </div>
}
export const vatIdStatus = (props) => {
  return props.options.unverified
    ? (props.options.loading ? <CircularProgress scale={0.5}/> :
      <button type="submit" className="btn btn-success w-100">Validate</button>)
    : <div className="align-content-center w-100"><i className="zmdi zmdi-lock text-success email-verified"/></div>
}
export const TermsAndConditionsText = (props) => <ul>
  <li><a target="_blank" href='https://specialists.lingoowl.com/terms-of-service/'>Terms of service (suppliers)</a></li>
  <li><a target="_blank" href="https://specialists.lingoowl.com/privacy/">Privacy</a></li>
  <li><a target="_blank" href="https://specialists.lingoowl.com/nda/">NDA (suppliers)</a></li>
</ul>



// WEBPACK FOOTER //
// ./Linkgua/components/SpecialistDetails/formWidgets.js